import React from 'react';
import { motion } from 'framer-motion';
import '../styles/EmptyState.css';

const EmptyState = ({ image, title, description, action, actionLabel, onAction }) => (
  <motion.div 
    className="empty-state"
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.4 }}
    role="status"
    aria-live="polite"
  >
    {image && <img src={image} alt="" className="empty-state-image" aria-hidden="true" />}
    <h3 className="empty-state-title">{title}</h3>
    <p className="empty-state-description">{description}</p>
    {action && (
      <button className="empty-state-action" onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </motion.div>
);

export default EmptyState; 